<template>
  <div class="admin-schedule-bars">
    <header-title title="Horarios de Cartas"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

    <!-- MENUS TIMING -->
    <template v-if="scheduleByMenu && scheduleByMenu.length > 0">
      <template v-if="display">
        <div
          v-for="(menuSchedule, index) in scheduleByMenu"
          :key="`menu_schedule_${index}`"
        >
          <schedule
            v-if="existMenu(menuSchedule.menuId)"
            :title="`Horario de ${getScheduleName(menuSchedule.menuId)}`"
            :display="display"
            :schedule-collection="mapMenuSchedule(menuSchedule.schedule)"
            @saveSchedule="saveMenuHour"
            :menu-schedule="menuSchedule"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { menusCollection } from "@/collections/menus";
import Loader from "@/components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import Schedule from "@/components/admin/schedule/Schedule.vue";
import {
  scheduleByMenuCollection,
  updateScheduleByMenu
} from "@/collections/scheduleByMenu";

const DAYS = [
  {
    name: "Lunes",
    value: 1
  },
  {
    name: "Martes",
    value: 2
  },
  {
    name: "Miercoles",
    value: 3
  },
  {
    name: "Jueves",
    value: 4
  },
  {
    name: "Viernes",
    value: 5
  },
  {
    name: "Sabado",
    value: 6
  },
  {
    name: "Domingo",
    value: 0
  }
];

export default {
  name: "ScheduleMenu",
  components: { Loader, HeaderTitle, Schedule },
  data() {
    return {
      days: DAYS,
      display: false,
      menus: [],
      scheduleByMenu: [],
      dialogLoader: true
    };
  },
  firestore() {
    return {
      menus: menusCollection,
      scheduleByMenu: scheduleByMenuCollection
    };
  },
  mounted() {
    let self = this;

    setTimeout(() => {
      self.display = true;
      this.dialogLoader = false;
    }, 300);
  },
  methods: {
    mapMenuSchedule(schedule) {
      let cloneMenuSchedule = JSON.parse(JSON.stringify(schedule));
      let array = [];
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(cloneMenuSchedule)) {
        array.push(value);
      }
      array.push(array.shift());
      return array;
    },
    getScheduleName(menuId) {
      let menu = this.menus.find(x => x.id === menuId);
      return menu !== undefined ? menu.name : "";
    },
    existMenu(menuId) {
      return this.menus.find(x => x.id === menuId) !== undefined;
    },
    async saveMenuHour(event, schedule, day, range, shift) {
      try {
        let selectDay = this.days[day].value;
        schedule.schedule[selectDay][shift][range] = parseFloat(event);
        await updateScheduleByMenu(schedule.id, schedule);

        this.showSuccesMessage();
      } catch (error) {
        this.setlogError(
          "update_schedule_by_menu",
          "Obtained error message in saveMenuHour()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    showSuccesMessage() {
      this.showSuccessMessage("Se ha actualizado la hora");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
